import { render, staticRenderFns } from "./UserPage.vue?vue&type=template&id=2878c3fd&scoped=true&"
import script from "./UserPage.vue?vue&type=script&lang=ts&"
export * from "./UserPage.vue?vue&type=script&lang=ts&"
import style0 from "./UserPage.vue?vue&type=style&index=0&id=2878c3fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2878c3fd",
  null
  
)

export default component.exports